module.exports = __webpack_public_path__ + "img/menu3.2a4646e7.png";